import React from 'react';
import './Message.css';

interface Source {
  chunk_id: string;
  text: string;
  metadata: any;
  relevance_score: number;
}

interface MessageProps {
  message: {
    role: 'user' | 'assistant';
    content: string;
    sources?: Source[];
    timestamp: Date;
  };
}

const Message: React.FC<MessageProps> = ({ message }) => {
  // Function to process content: remove chunk references and convert markdown to HTML
  const processContent = (content: string): string[] => {
    // Remove any lines that mention chunks or sources
    const lines = content
      .split('\n')
      .filter(line => {
        const lower = line.toLowerCase();
        return !lower.includes('this information is derived from') &&
               !(lower.includes('chunk') && (lower.includes('derived') || lower.includes('source'))) &&
               !(lower.includes('source') && lower.includes('derived'));
      });
    
    // Convert markdown bold **text** to HTML <strong>text</strong>
    // Also handle cases where there might still be markdown from older responses
    return lines.map(line => 
      line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    );
  };

  const processedLines = processContent(message.content);

  return (
    <div className={`message ${message.role}-message`}>
      <div className="message-header">
        <span className="message-role">
          {message.role === 'user' ? '👤 You' : '📚 Prepwise Assistant'}
        </span>
        <span className="message-time">
          {message.timestamp.toLocaleTimeString()}
        </span>
      </div>
      <div className="message-content">
        {processedLines.map((line, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: line || '&nbsp;' }} />
        ))}
      </div>
    </div>
  );
};

export default Message;

